import { render, staticRenderFns } from "./CustomActivity.vue?vue&type=template&id=2b401604&scoped=true"
import script from "./CustomActivity.vue?vue&type=script&lang=js"
export * from "./CustomActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b401604",
  null
  
)

export default component.exports